export default __webpack_public_path__ + "622606cda8813014de88797d709bc173.svg";